export default {"src":"/_next/static/media/rpx.cc6482a4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};